// Root route — establishes the QueryClient context + renders nested routes.
// Per design/Handoff.html, the app shell is mounted under /app/* and
// authenticated routes live underneath. Public routes (sign-in) bypass
// the shell.

import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => <Outlet />,
});
